import { TBusinessOffice, TCompanyForm } from "@/features/company/types/CompanyForm";
import { FC } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { Grid, Typography } from "@mui/material";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";

type TBusinessOfficeDetailProps = {
  defaultValues?: Partial<TCompanyForm>;
};
export const BusinessOfficeDetail: FC<TBusinessOfficeDetailProps> = ({ defaultValues }) => {
  const businessOffices = defaultValues?.businessOffices || [];
  const title = (index: number) => (businessOffices.length > 1 ? `営業所 ${index + 1}` : `営業所`);
  return (
    <InnerBox title={<CompanyFormTitle text="営業所情報" />} showDivider={false}>
      {businessOffices.map((office: TBusinessOffice, index: number) => (
        <InnerBox
          title={<Typography variant="sub16Bold">{title(index)}</Typography>}
          showDivider={false}
          sx={{
            marginBottom: "16px",
          }}
        >
          <Grid container key={index} spacing={3}>
            <Grid item xs={12}>
              <CompanyInfoItem label="営業所名" value={office?.officeName} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="郵便番号" value={office?.zipCode} type="zipcode" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="都道府県" value={office?.prefecture} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="市区町村" value={office?.city} />
            </Grid>
            <Grid item xs={12}>
              <CompanyInfoItem label="市区町村以降の住所" value={office?.address} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="営業所代表電話番号" value={office?.telNumber} type="phone" />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="FAX番号" value={office?.faxNumber} type="phone" />
            </Grid>
            <Grid item xs={12}>
              <CompanyInfoItem label="この営業所について" value={office?.officeDescription} isShowDivider={false} />
            </Grid>
          </Grid>
        </InnerBox>
      ))}
    </InnerBox>
  );
};
